import { apiRequestDev } from './apiRequest';

export const getRidingInfo = async (config, userId) => apiRequestDev(config, `/ridings/user?id=${userId}`);
